import { saveSearchHistory } from "@/store/SearchStorage";

const SearchPlugin = (store) => {
  store.subscribe((mutation) => {
    if (mutation.type === "setSearchHistory") {
      const searchHistory = mutation.payload || [];

      saveSearchHistory(JSON.stringify(searchHistory));
    }
  });
};

export default SearchPlugin;
